import React, { Fragment } from 'react';
import { Icons, Header, Button, NoWrap } from 'components';
import { config, capitalize } from 'helpers';
import css from './plans.scss';

export function Plans(props) {
  const cost = /\s*\$[0-9.]+\s*USD\s*/;
  return (
    <div className={css.section}>
      <div className={[css.background, props.status].join(' ')} />
      <Header.Compensate ref={props.refHeaderBreakpoint} className={css.compensate} />
      <div className={css.container}>
        <h1>Programs</h1>
        <p>All Premium plans include full access to all features and functionality in the mobile apps (iPhone, iPad, Android) and full unlimited access to the comprehensive Web Program.</p>
      </div>

      <div className={css.plans}>
        { config.plans.map((plan, index) =>
          <div key={plan.code} className={[css.plan, props.status].join(' ')}>
            <div>

              { index == 0 && <p className={css.ribbonPlaceholder}>_</p> }
              { index == 1 && <p className={css.primaryRibbon}>Save { plan.save }</p> }
              { index == 2 && <p className={css.bestRibbon}><Icons.Star /><span>Save { plan.save } | Best Value</span></p> }

              { plan.tip &&
                <div className={css.trialRibbon}><span>{ plan.tip }</span></div>
              }

              <h5 className={css.title}>
                { index == 0 && 'Monthly Subscription' }
                { index > 0 && plan.title.replace(cost, ' Package') }
              </h5>

              <p className={css.cost}>
                <b>${ plan.cost }</b>
                <sub> USD</sub>
              </p>
              <p className={css.period}>{ plan.description.replace(cost, '') }</p>
              <ul>
                <li>{ capitalize(config.clarityModule) } Module</li>
                <li>{ capitalize(config.identityModule) } Module</li>
                <li>Goals Module</li>
                <li>Action Module</li>
                { config.sw && <li>Habits Section</li> }
                <li>Personal Journal and Notepad</li>
                <li>iPhone, iPad, Android Apps</li>
                <li>Team Collaboration</li>
                { index > 0 &&
                  <Fragment>
                    <li>Personal Coaching for <NoWrap>additional fee</NoWrap></li>
                    <li>Full Premium Program Access</li>
                  </Fragment>
                }
              </ul>
            </div>
            <p><Button unfilled primary to={`/sign-up/${ plan.code }/`}>Choose</Button></p>
          </div>
        ) }
      </div>

      <p className={css.tip}>* You can upgrade or cancel your membership anytime.</p>
    </div>
  );
}
